"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.takeoffLayout = void 0;
// @higgins/m2q-pricing — Measure2Quote's pricing core: the measuring maths,
// the STM002 take-off pricing, an option's choices, the Summary's cost-code
// groups, the REVIEW gate, an accepted option's opportunity lines, and the
// STM002 workbook itself (where its cells are, and filling a blank one, #516).
// Shared by the Measure2Quote SPA and its API, so the API re-prices on the server and
// never takes the browser's figures (PRICING.md "Accepting an option").
__exportStar(require("./measure.js"), exports);
__exportStar(require("./surfaces.js"), exports);
__exportStar(require("./units.js"), exports);
__exportStar(require("./site-reqs.js"), exports);
__exportStar(require("./option-scope.js"), exports);
__exportStar(require("./paint-systems.js"), exports);
__exportStar(require("./paint-completeness.js"), exports);
__exportStar(require("./pricing.js"), exports);
__exportStar(require("./pricing-inputs.js"), exports);
__exportStar(require("./approved-hours.js"), exports);
__exportStar(require("./job-prices.js"), exports);
__exportStar(require("./version-snapshot.js"), exports);
__exportStar(require("./surface-rows.js"), exports);
__exportStar(require("./summary.js"), exports);
__exportStar(require("./review.js"), exports);
__exportStar(require("./accept.js"), exports);
__exportStar(require("./maintenance.js"), exports);
__exportStar(require("./maintenance-contract.js"), exports);
__exportStar(require("./maintenance-accept.js"), exports);
__exportStar(require("./maintenance-payments.js"), exports);
__exportStar(require("./maintenance-scope.js"), exports);
__exportStar(require("./yearly-summary.js"), exports);
exports.takeoffLayout = require("./takeoff-layout.js");
__exportStar(require("./takeoff-xlsx.js"), exports);
__exportStar(require("./takeoff-fill.js"), exports);
__exportStar(require("./takeoff-sections.js"), exports);
__exportStar(require("./takeoff-check.js"), exports);
__exportStar(require("./file-name.js"), exports);
